const API_URL = process.env.REACT_APP_API_URL;
const SUBSCRIPTION_URL = `${API_URL}/api/subscription`;

export const fetchSubscriptionPlans = async () => {
    try {
        const response = await fetch(`${SUBSCRIPTION_URL}/plans`, {
            method: 'GET',
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch subscription plans');
        }

        return response.json();
    } catch (error) {
        console.error('Error fetching subscription plans:', error);
        throw error;
    }
};

export const subscribeToPlan = async planId => {
    try {
        const response = await fetch(`${SUBSCRIPTION_URL}/subscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ planId }),
        });

        if (!response.ok) {
            throw new Error('Failed to subscribe to plan');
        }

        return response.json();
    } catch (error) {
        console.error('Error subscribing to plan:', error);
        throw error;
    }
};

export const fetchUsageSummary = async (from, to) => {
    try {
        const params = new URLSearchParams();
        if (from) params.set('from', from);
        if (to) params.set('to', to); // to is exclusive ISO string from client
        const url = `${SUBSCRIPTION_URL}/usage/summary?${params.toString()}`;
        const res = await fetch(url, { credentials: 'include' });
        if (!res.ok) throw new Error('Failed to fetch usage summary');
        return res.json();
    } catch (error) {
        console.error('Error fetching usage summary:', error);
        throw error;
    }
};

export const fetchUsageTransactions = async ({ from, to, page = 1, limit = 50 }) => {
    try {
        const params = new URLSearchParams();
        if (from) params.set('from', from);
        if (to) params.set('to', to); // exclusive upper bound
        params.set('page', String(page));
        params.set('limit', String(limit));
        const url = `${SUBSCRIPTION_URL}/usage/transactions?${params.toString()}`;
        const res = await fetch(url, { credentials: 'include' });
        if (!res.ok) throw new Error('Failed to fetch usage transactions');
        return res.json();
    } catch (error) {
        console.error('Error fetching usage transactions:', error);
        throw error;
    }
};
